
export default function (value, separator = ', ') {
  return value.join(separator)
}



// WEBPACK FOOTER //
// ./src/filters/join.js